import { Suspense, lazy } from 'react';

const FoldersOverview = lazy(() => import('../components/Folders/FoldersOverview'));

const FoldersOverviewLazy: React.FC = () => {
    return <Suspense><FoldersOverview/></Suspense>;
}

export default FoldersOverviewLazy;